/**
 * Libellés des pages (fil d'Ariane, titre d'onglet par défaut).
 */

// Libellé lisible de chaque adresse
export const LABELS = {
  dashboard: 'Tableau de bord',
  notifications: 'Notifications',
  profil: 'Mon profil',
  'modifier-profil': 'Modifier mon profil',
  settings: 'Paramètres',
  admin: 'Administration',
  'mes-projets': 'Mes projets',
  submit: 'Présenter mon projet',
  paiement: 'Paiement',
  retour: 'Résultat',
  projects: 'Projets',
  project: 'Projets',
  'investissement-revenus': 'Investir',
  'epargne-positive': 'Épargne positive',
  diaspora: 'Diaspora',
  eligibilite: "Test d'éligibilité",
  incubateur: 'Incubateur du Centre Hub',
  'pour-qui': 'Pour qui ?',
  agenda: 'Agenda',
  'etudes-de-cas': 'Études de cas',
  ressources: 'Ressources',
  'devenir-mentor': 'Devenir mentor',
  'faire-un-don': 'Faire un don',
  'verifier-identite': 'Vérifier mon identité',
  'support-investisseurs': 'Aide aux investisseurs',
  onboarding: 'Premiers pas',
  financement: 'Financer mon projet',
  'support-entrepreneurs': 'Aide aux entrepreneurs',
  'criteres-selection': 'Critères de sélection',
  about: 'Qui sommes-nous',
  vision: 'Notre vision',
  equipe: 'Équipe',
  partenaires: 'Partenaires',
  partnership: 'Devenir partenaire',
  presse: 'Espace presse',
  candidature: 'Candidature',
  recrutement: 'Recrutement',
  contact: 'Contact',
  blog: 'Actualités',
  newsletter: 'Newsletter',
  search: 'Recherche',
  engagements: 'Nos engagements',
  transparence: 'Transparence',
  'impact-social': 'Impact social',
  ecologie: 'Écologie',
  inclusion: 'Inclusion',
  securite: 'Sécurité',
  stats: 'Statistiques',
  rapports: 'Rapports',
  'tableaux-de-bord': 'Tableaux de bord',
  'indicateurs-performance': 'Indicateurs',
  features: 'Fonctionnalités',
  cgu: "Conditions d'utilisation",
  'mentions-legales': 'Mentions légales',
  confidentialite: 'Confidentialité',
  cookies: 'Cookies',
  reclamations: 'Réclamations',
  'verifier-recu': 'Vérifier un reçu'
};

// Segments sans page propre : lien vers la page parente existante
export const SEGMENT_ROUTES = { project: '/projects', paiement: '/profil' };

// Dernier segment d'une page de détail (identifiant) : libellé générique
export const DETAIL_LABELS = { projects: 'Fiche projet', project: 'Fiche projet', blog: 'Article', ressources: 'Modèle', 'verifier-recu': 'Vérifier un reçu' };

/** Libellé d'une adresse, ex. /projects/static-1 → « Fiche projet » */
export const labelForPath = (pathname) => {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) return null;
  const last = segments[segments.length - 1];
  const parent = segments[segments.length - 2];
  return LABELS[last] || (parent && DETAIL_LABELS[parent]) || null;
};
